import ReactGA from 'react-ga4'
import ga from 'config/ga'

/**
 * Returns the config and the react-ga instance
 * @returns {array}
 */
export const useGA = () => [ga, ReactGA]
